import { useMutation as e, useQuery as t, useQueryClient as n } from "@tanstack/react-query";
import { http as r, toListPage as i } from "@frontends/data-access-spg-api";
//#region src/lib/api/mappers.ts
function a(e) {
	return {
		id: e.id,
		name: e.name,
		botId: e.bot_id,
		entryFlowId: e.entry_flow_id,
		enabled: e.enabled,
		channels: (e.channels ?? []).map((e) => ({
			id: e.id,
			externalId: e.external_id,
			title: e.title
		}))
	};
}
function o(e) {
	return {
		name: e.name,
		bot_id: e.botId,
		entry_flow_id: e.entryFlowId,
		channel_ids: e.channelIds
	};
}
//#endregion
//#region src/lib/api/instancesApi.ts
var s = (e) => `/instances/${encodeURIComponent(e)}`;
async function c(e) {
	let { data: t } = await r.get("/instances", { signal: e });
	return t.map(a);
}
async function l(e, t) {
	let { data: n } = await r.get(s(e), { signal: t });
	return a(n);
}
async function u(e) {
	let { data: t } = await r.post("/instances", o(e));
	return a(t);
}
async function d(e, t) {
	await r.patch(s(e), { enabled: t });
}
async function f(e, t) {
	await r.patch(s(e), { name: t });
}
async function p(e) {
	await r.delete(s(e));
}
async function m(e, t) {
	await r.post(`${s(e)}/channels`, { channel_id: t });
}
async function h(e, t) {
	await r.delete(`${s(e)}/channels/${encodeURIComponent(t)}`);
}
//#endregion
//#region src/lib/queries.ts
var g = {
	all: ["instances"],
	list: () => [...g.all, "list"],
	detail: (e) => [
		...g.all,
		"detail",
		e
	]
};
function _(e, n) {
	return t({
		queryKey: g.list(),
		queryFn: ({ signal: e }) => c(e),
		select: (t) => i(t.filter((e) => e.name.toLowerCase().includes(n.query.toLowerCase())), e, (e, t) => e[t])
	});
}
function v() {
	return t({
		queryKey: g.list(),
		queryFn: ({ signal: e }) => c(e)
	});
}
function y(e) {
	return t({
		queryKey: g.detail(e),
		queryFn: ({ signal: t }) => l(e, t)
	});
}
//#endregion
//#region src/lib/mutations.ts
function b(e, t) {
	return Promise.all([e.invalidateQueries({ queryKey: g.detail(t) }), e.invalidateQueries({ queryKey: g.list() })]);
}
function x() {
	let t = n();
	return e({
		mutationFn: u,
		onSuccess: () => t.invalidateQueries({ queryKey: g.list() })
	});
}
function S() {
	let t = n();
	return e({
		mutationFn: ({ id: e, enabled: t }) => d(e, t),
		onSuccess: (e, { id: n }) => b(t, n)
	});
}
function C() {
	let t = n();
	return e({
		mutationFn: ({ id: e, channelId: t }) => m(e, t),
		onSuccess: (e, { id: n }) => b(t, n)
	});
}
function w() {
	let t = n();
	return e({
		mutationFn: ({ id: e, channelId: t }) => h(e, t),
		onSuccess: (e, { id: n }) => b(t, n)
	});
}
function T() {
	let t = n();
	return e({
		mutationFn: ({ id: e, name: t }) => f(e, t),
		onSuccess: (e, { id: n }) => b(t, n)
	});
}
function E() {
	let t = n();
	return e({
		mutationFn: p,
		onSuccess: (e, n) => (t.removeQueries({ queryKey: g.detail(n) }), t.invalidateQueries({ queryKey: g.list() }))
	});
}
//#endregion
export { g as instancesQueryKeys, v as useAllInstancesQuery, C as useAttachChannelMutation, x as useCreateInstanceMutation, E as useDeleteInstanceMutation, w as useDetachChannelMutation, y as useInstanceQuery, _ as useInstancesQuery, T as useRenameInstanceMutation, S as useSetInstanceEnabledMutation };
